import { ReactNode, useEffect } from 'react';

import { FormProvider, useForm } from 'react-hook-form';

import { Form } from '~/components/ui/Form';

import { UserFormDelete } from './components/UserFormDelete';
import { UserFormFooter } from './components/UserFormFooter';
import { UserFormInfo } from './components/UserFormInfo';
import { UserFormLogout } from './components/UserFormLogout';
import { UserFormOAuth } from './components/UserFormOAuth';
import { UserFormPolicy } from './components/UserFormPolicy';

import type { UserFormValues } from './libs/types';

export interface UserFormProps {
  defaultValues?: UserFormValues;
  children: ReactNode;
  onSubmit: (data: UserFormValues) => void;
}

export const UserForm = (props: UserFormProps) => {
  const { defaultValues, children, onSubmit } = props;

  const methods = useForm<UserFormValues>({
    defaultValues,
  });

  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues]);

  return (
    <Form onSubmit={methods.handleSubmit(onSubmit)}>
      <FormProvider {...methods}>{children}</FormProvider>
    </Form>
  );
};

UserForm.Info = UserFormInfo;
UserForm.Policy = UserFormPolicy;
UserForm.Logout = UserFormLogout;
UserForm.Delete = UserFormDelete;
UserForm.OAuth = UserFormOAuth;
UserForm.Footer = UserFormFooter;
